// Prayosha Construction - Mock Data

export const companyInfo = {
  name: "Prayosha Construction",
  tagline: "Building with Integrity. Delivering Beyond Expectations.",
  established: 1995,
  experience: "30+",
  location: "Anand, Gujarat, India",
  phone: "+91 99790 42010",
  email: "kamlesh1877@gmail.com",
  address: "F/7, Ganesh Complex, Ganesh X, Anand – 388001, Gujarat, India",
  description: "Prayosha Construction is a trusted civil construction firm established in 1995, specialising in residential buildings, renovation work, additions, alterations, extensions, and complete new construction projects across Gujarat."
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Projects", path: "/projects" },
  { label: "Leadership", path: "/leadership" },
  { label: "Contact", path: "/contact" }
];

export const heroContent = {
  headline: "Building Trust Through Quality Construction",
  subheadline: "Family-owned civil construction firm with over 30 years of experience in residential, industrial, and institutional projects across Gujarat.",
  primaryCta: "Get a Quote",
  secondaryCta: "View Our Projects",
  image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3MDkzNDg1Nnww&ixlib=rb-4.1.0&q=85"
};

export const stats = [
  { value: "30+", label: "Years of Experience" },
  { value: "50+", label: "Projects Completed" },
  { value: "200+", label: "Satisfied Clients" },
  { value: "5+", label: "Active Projects" }
];

export const services = [
  {
    id: 1,
    title: "New Construction",
    icon: "Building2",
    shortDescription: "Complete construction of residential, industrial, and institutional buildings from foundation to finishing.",
    fullDescription: "We undertake full-scale construction projects from initial planning through completion. Our team handles everything from site preparation and foundation work to structural construction and final finishing. With decades of experience, we ensure each project meets the highest standards of quality and safety.",
    features: ["Site preparation & foundation", "Structural construction", "Plumbing & electrical", "Interior & exterior finishing"]
  },
  {
    id: 2,
    title: "Renovation & Remodeling",
    icon: "Hammer",
    shortDescription: "Modernise and upgrade existing structures while preserving their integrity and improving functionality.",
    fullDescription: "Whether it's updating interiors, reconfiguring floor plans, or modernising outdated infrastructure, our renovation work blends new construction standards with the character of the original structure. We work closely with clients to understand their vision while ensuring structural safety.",
    features: ["Interior remodeling", "Structural upgrades", "Modern amenity integration", "Floor plan reconfiguration"]
  },
  {
    id: 3,
    title: "Repair & Maintenance",
    icon: "Wrench",
    shortDescription: "Regular upkeep and timely repairs to extend the life of your property and prevent structural issues.",
    fullDescription: "Proper maintenance prevents small problems from becoming expensive repairs. We provide both scheduled maintenance services and emergency repair work for residential complexes, commercial properties, and industrial facilities. Our team identifies issues early and addresses them efficiently.",
    features: ["Structural repair", "Waterproofing", "Crack treatment", "Preventive maintenance"]
  },
  {
    id: 4,
    title: "Addition & Alteration",
    icon: "PlusSquare",
    shortDescription: "Expand or modify your existing structure to accommodate new requirements without rebuilding.",
    fullDescription: "When your needs change, your building can change too. We handle additions like extra floors, new wings, and structural alterations that blend seamlessly with existing construction. Every modification is carefully planned to maintain structural integrity.",
    features: ["Floor additions", "Wing extensions", "Structural modification", "Load-bearing analysis"]
  },
  {
    id: 5,
    title: "Extension Work",
    icon: "Maximize2",
    shortDescription: "Extend your built-up area with carefully planned additions that integrate with the existing structure.",
    fullDescription: "We specialise in extending residential and commercial properties, adding functional space that matches the existing design and structure. From room extensions to compound expansions, every project is handled with precision and attention to load-bearing requirements.",
    features: ["Room extensions", "Compound expansion", "Covered area additions", "Terrace enclosures"]
  },
  {
    id: 6,
    title: "Structural Strengthening",
    icon: "Shield",
    shortDescription: "Reinforce and strengthen ageing or damaged structures to restore safety and extend building life.",
    fullDescription: "Older structures often need reinforcement to meet current safety standards or to bear additional loads. We use proven techniques like jacketing, carbon fibre wrapping, and underpinning to strengthen buildings without major disruption to occupants.",
    features: ["Column & beam jacketing", "Foundation underpinning", "Seismic retrofitting", "Load capacity enhancement"]
  },
  {
    id: 7,
    title: "Architectural & Civil Plans",
    icon: "PencilRuler",
    shortDescription: "Detailed floor plans, building plans, civil drawings, and 3D visualisations to bring your project vision to life before construction begins.",
    fullDescription: "We provide comprehensive architectural and civil planning services, from initial concept sketches to fully detailed construction drawings. Our plans include accurate floor layouts, structural drawings, elevation views, and realistic 3D renderings that help you visualise the final outcome. Whether it's a residential house plan or a commercial building blueprint, our experienced team ensures every detail is captured for smooth execution on site.",
    features: ["Floor plan design", "Building & civil drawings", "3D elevation & rendering", "AutoCAD drawings"]
  }
];

export const contractModels = [
  {
    id: 1,
    title: "Rate Contract",
    description: "Work is billed based on actual quantities at pre-agreed rates. Suitable for projects where the full scope may not be defined upfront.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Lump-Sum Contract",
    description: "A fixed total price is agreed upon before work begins. Best for well-defined projects with clear specifications and drawings.",
    icon: "IndianRupee"
  },
  {
    id: 3,
    title: "Labour Contract",
    description: "We provide skilled and unskilled labour for your project while you manage materials. A cost-effective approach for material-rich clients.",
    icon: "HardHat"
  },
  {
    id: 4,
    title: "Area-Based Contract",
    description: "Pricing is calculated per square foot or square metre. A transparent model commonly used for residential and commercial construction.",
    icon: "LayoutGrid"
  }
];

export const whyChooseUs = [
  {
    title: "Quality Workmanship",
    description: "Every project reflects our commitment to using the right materials, following proper construction practices, and delivering durable results.",
    icon: "CheckCircle2"
  },
  {
    title: "Reliable Execution",
    description: "We follow through on commitments. Our clients trust us because we do what we say — on time, within budget, and without shortcuts.",
    icon: "Clock"
  },
  {
    title: "Clear Communication",
    description: "We keep you informed at every stage. No surprises, no hidden costs — just straightforward updates and honest conversations.",
    icon: "MessageSquare"
  },
  {
    title: "Three Decades of Trust",
    description: "Established in 1995, our track record speaks for itself. Many of our clients have worked with us across multiple projects over the years.",
    icon: "Handshake"
  }
];

export const projects = [
  {
    id: 1,
    title: "Samruddhi Residency",
    category: "Residential",
    location: "Ahmedabad, Gujarat",
    year: "2023",
    scope: "New Construction",
    description: "A 24-unit residential complex with modern amenities, built from foundation to finishing over 18 months. Includes parking, landscaping, and common areas."
  },
  {
    id: 2,
    title: "Patel Industrial Warehouse",
    category: "Industrial",
    location: "Vadodara, Gujarat",
    year: "2022",
    scope: "New Construction",
    description: "A 40,000 sq.ft. industrial warehouse with heavy-duty flooring, ventilation systems, and loading dock facilities for a manufacturing client."
  },
  {
    id: 3,
    title: "Saraswati Vidya Mandir School",
    category: "Institutional",
    location: "Surat, Gujarat",
    year: "2022",
    scope: "Addition & Extension",
    description: "Addition of a new classroom wing with 12 rooms, a library, and a science laboratory to an existing school campus."
  },
  {
    id: 4,
    title: "Shreeji Housing Society Renovation",
    category: "Residential",
    location: "Rajkot, Gujarat",
    year: "2021",
    scope: "Renovation",
    description: "Complete renovation of a 30-year-old housing society including structural repairs, waterproofing, facade upgrades, and common area modernisation."
  },
  {
    id: 5,
    title: "Gujarat Textile Mills Office",
    category: "Industrial",
    location: "Ahmedabad, Gujarat",
    year: "2021",
    scope: "Renovation & Alteration",
    description: "Conversion of an old mill office space into a modern administrative block with new interiors, electrical systems, and safety upgrades."
  },
  {
    id: 6,
    title: "Akshar Apartments",
    category: "Residential",
    location: "Gandhinagar, Gujarat",
    year: "2020",
    scope: "New Construction",
    description: "A 16-unit apartment building with emphasis on natural ventilation, energy-efficient design, and quality finishing throughout."
  },
  {
    id: 7,
    title: "Community Health Centre",
    category: "Institutional",
    location: "Mehsana, Gujarat",
    year: "2020",
    scope: "New Construction",
    description: "Construction of a primary health centre with OPD facilities, pharmacy space, and staff quarters on a government contract."
  },
  {
    id: 8,
    title: "Navrang Industrial Park",
    category: "Industrial",
    location: "Bharuch, Gujarat",
    year: "2019",
    scope: "New Construction",
    description: "Development of 6 industrial shed units within a planned industrial park, complete with drainage, road access, and utility connections."
  },
  {
    id: 9,
    title: "Sunrise Row Houses",
    category: "Residential",
    location: "Anand, Gujarat",
    year: "2019",
    scope: "New Construction",
    description: "A row house project of 12 independent units with individual parking, garden areas, and consistent design language across all homes."
  },
  {
    id: 10,
    title: "Municipal Corporation Office",
    category: "Institutional",
    location: "Junagadh, Gujarat",
    year: "2018",
    scope: "Repair & Strengthening",
    description: "Structural strengthening and repair of a heritage municipal building, including column jacketing, beam repairs, and facade restoration."
  }
];

export const leadership = [
  {
    "id": 1,
    "name": "Kamleshbhai Prajapati",
    "role": "Owner",
    "experience": "30+ years",
    "description": "Founder of Prayosha Construction since 1995. Known for integrity, quality-focused execution, and long-term client relationships."
  },
  {
    "id": 2,
    "name": "Alpeshbhai Prajapati",
    "role": "Civil Engineer & Founder",
    "experience": "30+ years",
    "description": "B.E. (Civil). Leads planning, technical supervision, and execution with strong understanding of construction technology."
  },
  {
    "id": 4,
    "name": "Piyush Prajapati",
    "role": "Site Supervisor",
    "experience": "10+ years",
    "description": "Manages daily site supervision, labour coordination, and quality checks as per drawings and safety guidelines."
  },
  {
    "id": 3,
    "name": "Hiteshbhai Prajapati",
    "role": "Execution Head",
    "experience": "30+ years",
    "description": "Oversees on-site execution, scheduling, contractor coordination, and quality control to ensure timely delivery."
  }
];


export const milestones = [
  {
    year: "2025",
    title: "30 Years of Excellence",
    description: "Celebrating three decades of trusted civil construction services across residential, industrial, and institutional sectors."
  },
  {
    year: "2016–2018",
    title: "Kaira-Can Officers Quarter",
    description: "Executed renovation of Officers’ Quarter buildings at Kaira-Can Campus with focus on quality and structural safety.",
    link: {
      text: "Kaira-Can Campus",
      url: "https://www.kairacan.com/"
    }
  },
  {
    year: "2015–2016",
    title: "APO Ahmedabad Renovation",
    description: "Completed renovation works at APO Ahmedabad, expanding institutional project portfolio."
  },
  {
    year: "2011–2012",
    title: "Kaira-Can Campus Renovation",
    description: "Renovation of quarter buildings at Kaira-Can Campus, ensuring structural improvement and durability.",
    link: {
      text: "Kaira-Can Campus",
      url: "https://www.kairacan.com/"
    }
  },
  {
    year: "2009–2012",
    title: "Prayona Park Development",
    description: "Delivered building organizer project 'Prayona Park', contributing to organized residential development."
  },
  {
    year: "2008–2017",
    title: "Rotomag Company (Units 1–4)",
    description: "Executed major addition, alteration, and repair works for Rotomag Company industrial units over multiple phases.",
    link: {
      text: "Rotomag Company",
      url: "https://www.rotomag.com/"
    }
  },
  {
    year: "2007–2008",
    title: "Shrusti Bungalows",
    description: "Completed Shrusti Bungalows residential project, strengthening reputation in premium residential construction."
  },
  {
    year: "2003–2004",
    title: "Old Age Home Project",
    description: "Successfully completed construction of an Old Age Home building, marking expansion into institutional projects."
  },
  {
    year: "1995",
    title: "Company Founded",
    description: "Prayosha Construction established in Anand, Gujarat by Kamleshbhai Prajapati. Began executing residential civil construction projects."
  }
];

export const values = [
  {
    title: "Integrity",
    description: "We believe in honest dealings. What we promise is what we deliver — no hidden costs, no shortcuts.",
    icon: "ShieldCheck"
  },
  {
    title: "Quality",
    description: "Good construction starts with good materials and skilled hands. We never compromise on either.",
    icon: "Award"
  },
  {
    title: "Reliability",
    description: "Our clients trust us because we show up, follow through, and finish what we start — on time.",
    icon: "ThumbsUp"
  },
  {
    title: "Respect",
    description: "We treat every client, worker, and partner with the respect they deserve. Relationships matter to us.",
    icon: "Heart"
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3MDkzNDg1Nnww&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1630061712710-2539eb457c55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxidWlsZGluZyUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3NzA5MzQ4NjB8MA&ixlib=rb-4.1.0&q=85",
  services: "https://images.unsplash.com/photo-1601074231509-dce351c05199?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxidWlsZGluZyUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3NzA5MzQ4NjB8MA&ixlib=rb-4.1.0&q=85"
};

export const projectsData = [
  {
    "id": 1,
    "title": "Residential Building Projects",
    "category": "Residential",
    "location": "Anand, Gujarat",
    "year": "Since 1995",
    "scope": "New Construction",
    "description": "Execution of multiple residential building projects including independent houses and small residential complexes across Anand.",
    "link": null
  },
  {
    "id": 2,
    "title": "Old Age Home Building",
    "category": "Institutional",
    "location": "Gujarat",
    "year": "2003–2004",
    "scope": "New Construction",
    "description": "Construction of Old Age Home facility with complete civil works including foundation, structure, and finishing.",
    "link": null
  },
  {
    "id": 3,
    "title": "Shrusti Bungalows",
    "category": "Residential",
    "location": "Gujarat",
    "year": "2007–2008",
    "scope": "New Construction",
    "description": "Development of bungalow project with complete structural and finishing work.",
    "link": null
  },
  {
    "id": 4,
    "title": "Rotomeg Company Units 1–4",
    "category": "Industrial",
    "location": "Gujarat",
    "year": "2008–2017",
    "scope": "Addition, Alteration & Repair",
    "description": "Executed industrial repair, addition, and alteration works across multiple units over several years.",
    "link": "https://www.rotomeg.com/"
  },
  {
    "id": 5,
    "title": "Prayona Park",
    "category": "Residential",
    "location": "Gujarat",
    "year": "2009–2012",
    "scope": "Building Organizer Project",
    "description": "Organised and executed residential development project including structural and planning supervision.",
    "link": null
  },
  {
    "id": 6,
    "title": "Kaira-Can Campus Quarter Renovation",
    "category": "Institutional",
    "location": "Gujarat",
    "year": "2011–2012",
    "scope": "Renovation",
    "description": "Renovation and structural repair of residential quarters at Kaira-Can Campus.",
    "link": "https://www.kairacan.com/"
  },
  {
    "id": 7,
    "title": "APO Ahmedabad Renovation",
    "category": "Institutional",
    "location": "Ahmedabad, Gujarat",
    "year": "2015–2016",
    "scope": "Renovation",
    "description": "Executed renovation work for APO Ahmedabad including civil modifications and repairs.",
    "link": null
  },
  {
    "id": 8,
    "title": "Kaira-Can Officers Quarter Renovation",
    "category": "Institutional",
    "location": "Gujarat",
    "year": "2016–2018",
    "scope": "Renovation & Repair",
    "description": "Renovation of officers’ quarter buildings focusing on durability, structural safety, and quality finishing.",
    "link": null
  },
  {
    "id": 9,
    "title": "Company Profile & Portfolio",
    "category": "Reference",
    "location": "Online",
    "year": "2025",
    "scope": "Digital Profile",
    "description": "Official Prayosha Construction company profile and project portfolio.",
    "link": "https://prayoshaconstruction.com"
  }
];
